export default __webpack_public_path__ + "static/media/radar_card_flipped.f645c55e.wav";